// "just now", "5 minutes ago", "1 hour ago", "3 days ago" for the top bar's Updated label.
// `now` is injectable so the caller can re-render on a timer and tests stay deterministic.
const plural = (count: number, unit: string) =>
  `${count} ${unit}${count === 1 ? '' : 's'} ago`;

const formatRelativeTime = (timestamp: number, now: number = Date.now()) => {
  const seconds = Math.max(0, Math.round((now - timestamp) / 1000));
  if (seconds < 45) return 'just now';
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return plural(minutes, 'minute');
  const hours = Math.round(minutes / 60);
  if (hours < 24) return plural(hours, 'hour');
  return plural(Math.round(hours / 24), 'day');
};

export default formatRelativeTime;
